import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M21.545 4.432a.75.75 0 1 1 0 1.5H20.19l-1.202 14.425a2.114 2.114 0 0 1-2.106 1.938H7.119c-1.1 0-2.016-.843-2.106-1.938L3.81 5.932H2.455a.75.75 0 0 1-.744-.648l-.006-.102a.75.75 0 0 1 .75-.75H7.84v-.614c0-1.116.866-2.03 1.963-2.108l.15-.005h4.091c1.168 0 2.114.946 2.114 2.113v.614zm-2.86 1.5H5.315l1.192 14.3a.614.614 0 0 0 .612.563h9.763c.32 0 .585-.244.611-.562l1.192-14.301zm-8.73 3.273a.75.75 0 0 1 .75.75v6.818a.75.75 0 0 1-1.5 0V9.955a.75.75 0 0 1 .75-.75zm4.09 0a.75.75 0 0 1 .75.75v6.818a.75.75 0 0 1-1.5 0V9.955a.75.75 0 0 1 .75-.75zm0-6h-4.09a.614.614 0 0 0-.614.613v.614h5.318v-.614a.614.614 0 0 0-.614-.613z' />
  </svg>
);
